import { createSlice } from '@reduxjs/toolkit';

// Integrations the manager has "added" in the dashboard but that the backend
// does not know about yet — e.g. Deliverect, whose row is created by the
// pos-bridge webhook once the manager finishes the setup on Deliverect's side.
// Persisted (via the root persist config) and keyed by company id so the setup
// card survives refetches, tab switches and reloads until the backend reports it.
export default createSlice({
  name: 'pendingIntegrations',
  initialState: {
    byCompany: {},
  },
  reducers: {
    add: (state, action) => {
      const { companyId, service } = action.payload;
      const current = state.byCompany[companyId] ?? [];

      if (current.includes(service)) {
        return;
      }

      state.byCompany[companyId] = [...current, service];
    },
    remove: (state, action) => {
      const { companyId, service } = action.payload;
      const next = (state.byCompany[companyId] ?? []).filter((item) => item !== service);

      if (next.length) {
        state.byCompany[companyId] = next;

        return;
      }

      delete state.byCompany[companyId];
    },
  },
});
